<template>
  <div 
    class="typewriter-container" 
    role="text" 
    :aria-label="`Current text: ${txt}`"
  >
    <span class="typewriter-badge">
      <svg class="sparkle-icon w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4L12 2z"/>
      </svg>
      <span class="typewriter-text">{{ txt }}</span>
      <span class="cursor" aria-hidden="true"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TypeWriter',
  props: {
    phrases: {
      type: Array,
      required: true,
      validator: (value) => value.length > 0
    },
    period: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      txt: '',
      loopNum: 0,
      isDeleting: false
    }
  },
  created() {
    this.timeoutId = null
  },
  mounted() {
    this.txt = ''
    this.tick()
  },
  beforeUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  },
  methods: {
    tick() {
      const i = this.loopNum % this.phrases.length
      const fullTxt = this.phrases[i]

      this.txt = this.isDeleting 
        ? fullTxt.substring(0, this.txt.length - 1) 
        : fullTxt.substring(0, this.txt.length + 1)

      let delta = 160 - Math.random() * 80

      if (this.isDeleting) {
        delta /= 2
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period
        this.isDeleting = true
      } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false
        this.loopNum++
        delta = 450
      }

      this.timeoutId = setTimeout(() => {
        requestAnimationFrame(this.tick)
      }, delta)
    }
  }
}
</script>

<style scoped>
.typewriter-container {
  display: inline-flex;
  align-items: center;
}

.typewriter-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.95rem;
  background-color: #FEF08A;
  border: 2.5px solid #121212;
  border-radius: 12px;
  box-shadow: 4px 4px 0 #121212;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 800;
  font-size: clamp(1rem, 2.2vw, 1.35rem);
  color: #121212;
  line-height: 1.2;
}

.sparkle-icon {
  color: #121212;
  flex-shrink: 0;
}

.typewriter-text {
  letter-spacing: -0.01em;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 1.2em;
  background-color: #121212;
  margin-left: 2px;
  animation: blink 0.9s infinite;
  vertical-align: middle;
  border-radius: 1px;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .cursor {
    animation: none;
    opacity: 1;
  }
}
</style>